import { config } from "env-config";

export function windowReplace(path: string) {
  window.location.replace(config.basePath ?? '/client' + path);
}